import {ErrorState} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {ActionTypeLoggingAccessEnum} from 'domain/usecases/private/my-hospitalization/post-logging-access';
import {LayoutContainer} from '../../components/LayoutContainer';
import {LoadingSkeleton} from '../../components/LoadingSkeleton';
import {OpinionCardsGrid} from './components/OpinionCardsGrid';
import {useOpinions} from './hooks/useOpinions';
import {EmptyStateHospitalization} from '../../components/EmptyState';
import {useMyHospitalizationLoggingAccess} from '../../hooks/useMyHospitalizationLoggingAccess';

const {error, empty} = translations['pt-br'].privateFlow.myHospitalization.opinions;

export const MyHospitalizationOpinions = () => {
	useMyHospitalizationLoggingAccess(ActionTypeLoggingAccessEnum.OPINIONS);
	const {data, isEmpty, isError, isLoading, refetch} = useOpinions();

	if (isLoading) {
		return (
			<LayoutContainer>
				<LoadingSkeleton />
			</LayoutContainer>
		);
	}

	if (isError) {
		return (
			<LayoutContainer>
				<ErrorState
					title={error.title}
					description={error.description}
					handleRefresh={refetch}
				/>
			</LayoutContainer>
		);
	}

	if (isEmpty) {
		return (
			<LayoutContainer>
				<EmptyStateHospitalization
					iconName="text-box-outline"
					title={empty.title}
					description={empty.description}
				/>
			</LayoutContainer>
		);
	}

	return (
		<LayoutContainer>
			<OpinionCardsGrid list={data} />
		</LayoutContainer>
	);
};
